import { makeStyles } from '@material-ui/core/styles';
import {
  BackgroundColors,
  SurfaceColors,
  TextColors,
  SecondaryColors,
  TextOpacities,
} from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      width: '100%',
      '@media print': {
        size: 'landscape',
        marginLeft: -18,
        width: '100%',
      },
    },
    headerRow: {
      '&.MuiTableRow-head': {
        backgroundColor: BackgroundColors.dark,
      },
    },
    headerCell: {
      '&.MuiTableCell-head': {
        ...muiTheme.typography.body2,
        padding: muiTheme.spacing(1.5),
        minWidth: 0,
        lineHeight: 'normal',
        fontWeight: 400,

        [muiTheme.breakpoints.up('md')]: {
          padding: muiTheme.spacing(1.5),
        },
      },

      '&.MuiTableCell-head small': {
        marginTop: muiTheme.spacing(0.3),
        whiteSpace: 'nowrap',
        display: 'block',
      },

      '&.MuiTableCell-head:first-child': {
        paddingLeft: muiTheme.spacing(2),

        [muiTheme.breakpoints.up('md')]: {
          paddingLeft: muiTheme.spacing(3),
        },
      },

      '&.MuiTableCell-head:last-child': {
        paddingRight: muiTheme.spacing(2),

        [muiTheme.breakpoints.up('md')]: {
          paddingRight: muiTheme.spacing(3),
        },
      },

      '&.MuiTableCell-head .MuiButtonBase-root, & .MuiButtonBase-root .MuiSvgIcon-root': {
        color: hexToRGBA(TextColors.light, TextOpacities.dark1),
      },
      '&.MuiTableCell-head .MuiTableSortLabel-active, & .MuiTableSortLabel-active .MuiSvgIcon-root':
        {
          color: TextColors.light,
        },
      '&.MuiTableCell-head:hover': {
        '& .MuiButtonBase-root, & .MuiButtonBase-root .MuiSvgIcon-root': {
          color: hexToRGBA(TextColors.light, 1),
        },
        '& .MuiTableSortLabel-active, & .MuiTableSortLabel-active .MuiSvgIcon-root': {
          color: TextColors.light,
        },
      },

      '&.MuiTableCell-head small .MuiButtonBase-root .MuiSvgIcon-root': {
        opacity: 1,
      },
    },
    bodyRow: {
      '&:nth-child(even)': {
        backgroundColor: hexToRGBA(BackgroundColors.light, 0.6),
      },
    },
    bodyCell: {
      '&.MuiTableCell-body': {
        ...muiTheme.typography.body2,
        padding: muiTheme.spacing(1.5),
        lineHeight: 'normal',
        border: '0 !important',
        minWidth: 0,
        fontWeight: 400,
      },

      '&.MuiTableCell-body:hover': {
        cursor: 'pointer',
      },

      '&.MuiTableCell-body:first-child': {
        paddingLeft: muiTheme.spacing(3),
      },

      '&.MuiTableCell-body:last-child': {
        paddingRight: muiTheme.spacing(3),
      },
    },
    spinnerCell: {
      padding: muiTheme.spacing(6),
    },
    table: {
      minWidth: 750,

      '&': {
        backgroundColor: SurfaceColors.light,

        ...muiTheme.typography.body2,

        [muiTheme.breakpoints.down('sm')]: {
          marginLeft: muiTheme.spacing(4),
        },
      },

      '& a': {
        color: SecondaryColors.dark,
      },

      '& a:hover': {
        color: TextColors.dark,
      },
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    modal: {
      width: '100%',
    },
  }),
  { name: 'GenSDLPaginatedTable' },
);

export default useStyles;
